const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế từng lần phát sinh ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxpayerId: {
      name: "taxpayerId",
      label: "[05] Mã số thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Số không hợp lệ",
    },
    capitalTransfereeName: {
      name: "capitalTransfereeName",
      label: "[06] Tên tổ chức/cá nhân nhận vốn chuyển nhượng",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức/cá nhân nhận vốn chuyển nhượng",
    },
    capitalTransfereeTaxId: {
      name: "capitalTransfereeTaxId",
      label:
        "[07] Mã số thuế/số chứng minh nhân dân/số căn cước công dân (đối với cá nhân chưa có mã số thuế)",
      type: "text",
      errorMsg: "Vui lòng nhập mã số",
      invalidMsg: "Số không hợp lệ",
    },
    capitalTransfereeTp: {
      name: "capitalTransfereeTp",
      label: "[08] Tỉnh/TP",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn tỉnh/TP",
    },
    capitalTransfereeDistrict: {
      name: "capitalTransfereeDistrict",
      label: "Quận/Huyện",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn quận/huyện",
    },
    capitalTransfereeWards: {
      name: "capitalTransfereeWards",
      label: "Phường/Xã",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn phường/xã",
    },
    capitalTransfereeAddress: {
      name: "capitalTransfereeAddress",
      label: "Địa chỉ",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    realEstateTp: {
      name: "realEstateTp",
      label: "[09d] Tỉnh/TP",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn tỉnh/TP",
    },
    realEstateDistrict: {
      name: "realEstateDistrict",
      label: "[09c] Quận/Huyện",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn quận/huyện",
    },
    realEstateWards: {
      name: "realEstateWards",
      label: "[09b] Phường/Xã",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn phường/xã",
    },
    realEstateAddress: {
      name: "realEstateAddress",
      label: "[09a] Địa chỉ",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    contractNumber: {
      name: "contractNumber",
      label: "Hợp đồng chuyển nhượng bất động sản: Số:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập số hợp đồng chuyển nhượng",
    },
    contractDay: {
      name: "contractDay",
      label: "Ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày hợp đồng chuyển nhượng",
    },
    confirmContractDay: {
      name: "confirmContractDay",
      label: "có công chứng hoặc chứng thực tại UBND phường (xã) ngày (nếu có)",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[10] Tên đại lý thuế (nếu có)",
      type: "text",
    },
    taxAgentId: {
      name: "taxAgentName",
      label: "[11] Mã số thuế",
      type: "text",
    },

    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
